export default [
    {
        path: '/dictionary-enact',
        name: 'enactdictionary',
        component: () => import(/* webpackChunkName:'di'*/ '@/views/enactDictionary/EnactDictionaryList.vue'),
        meta: {},
    },
    {
        path: '/sync-dictionary',
        name: 'syncdictionary',
        component: () => import(/* webpackChunkName:'di'*/ '@/views/enactDictionary/SyncDictionaryList.vue'),
        meta: {},
    }
];